const Center = () => import('@/views/workPlan/Center')
const Index = () => import('@/views/workPlan/Index')
export default [{
  path: '/workPlan',
  meta: {
    title: '养护作业'
  },
  components: {
    default: Center,
    right: Index
  },
  redirect: '/workPlan/planList',
  children: [{
    path: '/workPlan/planList',
    meta: {
      title: '养护计划',
      hasBack: false,
      activeMenu: '/home/board'
    },
    component: () => import('@/views/workPlan/PlanList')
  }, {
    path: '/workPlan/dailyReport',
    meta: {
      title: '养护日报',
      hasBack: false,
      activeMenu: '/home/board'
    },
    component: () => import('@/views/workPlan/DailyReport')
  }, {
    path: '/workPlan/taskOrder',
    meta: {
      title: '任务工单',
      hasBack: false,
      activeMenu: '/home/board'
    },
    component: () => import('@/views/workPlan/TaskOrder')
  }]
}]
